import React from 'react';

interface ListingContainerTabsProps {
  listView: boolean;
  setListView: (listView: boolean) => void;
  mapEnabled?: boolean;
}

export function ListingContainerTabs({ listView, setListView, mapEnabled = true }: ListingContainerTabsProps) {
  return (
    <ul className="nav nav-tabs my-3">
      <li className="nav-item">
        <a
          className={`nav-link ${listView ? 'active' : ''}`}
          onClick={() => {
            setListView(true);
          }}
          style={{ cursor: 'pointer' }}
        >
          List View
        </a>
      </li>

      <li className="nav-item">
        <button
          type="button"
          className={`nav-link ${listView ? '' : 'active'}`}
          onClick={() => {
            setListView(false);
          }}
          disabled={!mapEnabled}
          title={mapEnabled ? undefined : 'Map view is available for Listings'}
        >
          Map View
        </button>
      </li>
    </ul>
  );
}
